import { PaymentType } from "@/types/payment";

export const usePaymentValidation = () => {
  const validatePaymentType = (type: string): PaymentType => {
    if (type === "credit" || type === "bank") {
      return type;
    }
    throw new Error(`Invalid payment type: ${type}`);
  };

  return { validatePaymentType };
};